<div style="    display: flex;
    justify-content: center;padding-top: 10px;padding-bottom:10px">

  <form style="max-width: 800px;margin-top: 30px"  [formGroup]="contactForm" autocomplete="off">
    <h3 style="font-weight: bold;text-align: center">{{"LOGIN.CONTACTS" | translate}}</h3>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12  row" style="margin-top: 30px">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
        <mat-form-field appearance="outline"  class="w-100" color="primary">
          <mat-label>{{"COMMON.NAME" | translate}}</mat-label>
          <input  matInput formControlName="fullName" required>
        </mat-form-field>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
        <mat-form-field appearance="outline"  class="w-100" color="primary" >
          <mat-label>{{"COMMON.EMAIL" | translate}}</mat-label>
          <input  matInput formControlName="email" required>
        </mat-form-field>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
        <mat-form-field appearance="outline"  class="w-100" color="primary" >
          <mat-label>{{"COMMON.MOBILE_NUMBER" | translate}}</mat-label>
          <input  matInput formControlName="phoneNumber" required>
        </mat-form-field>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">
        <mat-form-field  appearance="outline" class="w-100" color="primary">
          <mat-label>{{ 'ZATCA.MESSAGE'  | translate }}</mat-label>
          <textarea matInput formControlName="message"></textarea>
        </mat-form-field>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 row" style="justify-content: center">
        <button class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" mat-flat-button style="margin-bottom: 7px;"  color="primary" [disabled]="contactForm.invalid" (click)="save()">{{'COMMON.SEND' | translate}}</button>
      </div>
    </div>
  </form>

</div>
